var map = {
	"./alma.svg": "226a",
	"./bhv.svg": "c915",
	"./cheque.svg": "cf9e",
	"./credit-card.svg": "807a",
	"./espece.svg": "bc99",
	"./multipayment.svg": "85ca",
	"./reservation.svg": "6dcb",
	"./sepa.svg": "915f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c4b";